import React from 'react'
import { Box } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DownloadCard from 'pages/Download/DownloadCard'
import SectionHeader from 'components/SectionHeader'
import { downloads } from './downloads'
import { useTranslation } from 'react-i18next'

const DownloadPage = () => {
  const { t } = useTranslation()

  return (
    <FixedWidthContainer sx={{ my: '50px' }}>
      <SectionHeader title={t('download.title')} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5
        }}
      >
        {downloads.map(download => (
          <DownloadCard
            key={download.fileName}
            bucketName={download.bucketName}
            fileName={download.fileName}
            region={download.region}
            titleKey={download.titleKey}
            fileType={download.fileType}
          />
        ))}
      </Box>
    </FixedWidthContainer>
  )
}

export default DownloadPage
